import * as actions from 'constants/actions'
import * as codes from 'constants/errorCodes'

import {API_URL, SAUCE_API_URL} from 'config'
import idx from 'idx'
import axios from 'axios'
import errorDispatcher from 'utils/errorDispatcher'
import {push, goBack} from 'connected-react-router'
import {extractErrorCode} from "utils/api";
import {
    deletePersistentValue,
    deleteSessionToken,
    getAuthorizationHeader,
    getPersistentValue,
    setSessionToken
} from "utils/session";

export function loginUser(loginFields, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: actions.API_LOGIN_REQUEST})
        try {
            const response = await axios.post(
                `${SAUCE_API_URL}/login`,
                {email: loginFields.email, password: loginFields.password}
            )

            const token = response.data.sessionToken
            setSessionToken(token)

            const user = response.data.user
            user.fullName = user.name

            dispatch({
                type: actions.API_LOGIN_SUCCESS,
                token,
                user
            })

            if (callback) {
                dispatch(() => callback(user))
            }
            else {
                const full = getPersistentValue('fullRedirect')
                deletePersistentValue("fullRedirect")
                if (full) {
                    console.log("post login fullRedirect to", full)
                    window.location = full
                    return
                }

                const loc = getPersistentValue('redirect')
                deletePersistentValue("redirect")
                if (loc && loc !== '/') {
                    console.log("post login redirect to", loc)
                    dispatch(push(loc))
                }
                else {
                    dispatch(push('/account/home'))
                }
            }
        }
        catch (error) {
            const errorCode = idx(error, _ => _.response.status) === 401 ? codes.INVALID_CREDENTIALS_RESPONSE_CODE : ''
            errorDispatcher(errorCode, actions.API_LOGIN_ERROR, dispatch)
        }
    }
}

export function logoutUser() {
    return async function dispatcher(dispatch) {
        dispatch({type: actions.API_LOGOUT_REQUEST})

        try {
            await axios.post(
                `${SAUCE_API_URL}/session/logout`,
                getAuthorizationHeader()
            )
            dispatch({type: actions.API_LOGOUT_SUCCESS})
            deleteSessionToken()
            dispatch(push('/login'))
        }
        catch (error) {
            dispatch({
                type: actions.API_LOGOUT_ERROR,
                error,
            })
        }
    }
}

export function createUser({email, name, password}, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: actions.API_CREATE_USER_REQUEST})

        try {
            // This returns a session token, so we could store it here. However the existing code does a login with the
            // same details, plus this is called from multiple places - will leave the flow as it is at least for now
            // so as not to upset things.
            await axios.post(
                `${SAUCE_API_URL}/account/create`,
                {
                    name: name,
                    email: email,
                    password: password
                }
            ).then(() => {
                dispatch({type: actions.API_CREATE_USER_SUCCESS})

                if (callback) {
                    dispatch(callback)
                }
                else {
                    dispatch(push('/login'))
                }
            }).catch((error) => {
                return Promise.reject(error.response)
            })
        }
        catch (error) {
            const errorCode = idx(error, _ => _.data.status) || ''
            errorDispatcher(errorCode, actions.API_CREATE_USER_ERROR, dispatch)
        }
    }
}

export function updateUser(fields, emailChanged) {
    return async function dispatcher(dispatch) {
        dispatch({type: actions.API_EDIT_USER_REQUEST})

        try {
            const response = await axios.put(`${SAUCE_API_URL}/account`, {...fields}, getAuthorizationHeader())
            dispatch({type: actions.API_EDIT_USER_SUCCESS, user: response.data})
            dispatch(goBack())
        }
        catch (error) {
            const errorCode = extractErrorCode(error, "updateUser")
            errorDispatcher(errorCode, actions.API_EDIT_USER_ERROR, dispatch)
        }
    }
}

export function updatePassword(oldPassword, newPassword) {
    return async function dispatcher(dispatch) {
        try {
            dispatch({type: actions.API_EDIT_PASSWORD_REQUEST})
            await axios.post(
                `${API_URL}/account/change-password`,
                {oldPassword, newPassword},
                getAuthorizationHeader()
            )
            dispatch(push('/account/home'))
            dispatch({type: actions.API_EDIT_PASSWORD_SUCCESS})
        }
        catch (error) {
            const errorCode = extractErrorCode(error)
            errorDispatcher(errorCode, actions.API_EDIT_PASSWORD_ERROR, dispatch)
        }
    }
}

export function resetPasswordRequest(email, callback) {
    return async function dispatcher(dispatch) {
        dispatch({type: actions.API_RESET_REQUEST_REQUEST})

        try {
            await axios.post(`${SAUCE_API_URL}/account/request-password-reset`, {email})
            dispatch({type: actions.API_RESET_REQUEST_SUCCESS})

            if (callback) {
                dispatch(() => callback())
            }
        }
        catch (error) {
            console.error("resetPasswordRequest", error)
            const errorCode = idx(error, _ => _.data.status) || ''
            errorDispatcher(errorCode, actions.API_RESET_REQUEST_ERROR, dispatch)
        }
    }
}

export function resetPassword(password, token) {
    return async function dispatcher(dispatch) {
        dispatch({type: actions.API_RESET_PASSWORD_REQUEST})
        try {
            await axios.post(`${API_URL}/account/reset-password/${token}`, {password})
            dispatch({type: actions.API_RESET_PASSWORD_SUCCESS})
        }
        catch (error) {
            console.error("resetPassword", error)
            const errorCode = idx(error, _ => _.response.status) || ''
            errorDispatcher(errorCode, actions.API_RESET_PASSWORD_ERROR, dispatch)
        }
    }
}

export function verifyEmail(token) {
    return async function dispatcher(dispatch) {
        dispatch({type: actions.API_VERIFY_EMAIL_REQUEST})

        try {
            await axios.put(`${SAUCE_API_URL}/contact-method/verify`, {
                token
            }).then((result) => {
                const data = idx(result, _ => _.data.data.rows[0]) || null
                dispatch({
                    type: actions.API_VERIFY_EMAIL_SUCCESS,
                    data
                })
                return Promise.resolve(result)
            }).catch((error) => {
                return Promise.reject(error)
            })
        }
        catch (error) {
            const errorCode = idx(error, _ => _.data.status) || ''
            // dispatch(push('/login'))
            errorDispatcher(errorCode, actions.API_VERIFY_EMAIL_ERROR, dispatch)
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js